export default "__VITE_ASSET__DxAizGJ9__"